import ChartColors from '../../../../js/utility/ChartColors';
import translator from '../../translator';
import {LABEL_KEYS, RenderContext} from '../types';

export function createRenderContext(): RenderContext {
    return {
        dark: ChartColors.isDarkTheme(),
        palette: ChartColors.COLORS,
        locale: translator.lang || document.documentElement.lang || 'en',
        labels: Object.fromEntries(LABEL_KEYS.map(key => [key, translator.translate(key)])),
    };
}
